export function qfolderobj() {
  this.name = null;
  this.groupstatus = null;
}
